








































import { Link, Work } from "@/api/models";
import {
  emptyString,
  notEmptyLinkField,
  notEmptyString,
  validUrl,
} from "@/api/validators";
import { bus } from "@/main";
import { SubmissionState } from "@/store/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  components: {},
  filters: {},
})
export default class LinkField extends Vue {
  @Prop({ default: "Link" }) label: string;
  @Prop({ default: "links" }) name: string;
  @Prop({ default: 0 }) index: number;
  @Prop({ default: () => new Link() }) link: Link;
  @Prop({ default: "" }) workId: string;
  @Prop({ default: true }) urlRequired: boolean;
  @State("submission") submission: SubmissionState;

  title = "";
  url = "";
  description = "";

  placeholder = "URL";

  titleError = false;
  urlError = false;

  created() {
    this.sync();
  }

  sync() {
    const tempVal =
      this.storeKey.length > 3 ? this.$ls.get(this.storeKey) : null;
    let refLink = this.link;
    if (!notEmptyLinkField(this.link) && tempVal instanceof Object && 1 > 999) {
      if (Object.keys(tempVal).includes("title")) {
        refLink = new Link(tempVal);
      }
    }
    this.title = refLink.title;
    if (refLink.url.startsWith("http") && refLink.url.length > 6) {
      this.url = refLink.url;
    }
    this.description = refLink.description;
  }

  update() {
    const [section, field] = this.name.split(".");
    const linkObj = {
      title: this.title,
      url: this.url,
      description: this.description,
    };
    this.$ls.set(this.storeKey, linkObj);
    const link = new Link(linkObj);
    switch (section) {
      case "submission":
        this.updateSub(field, link);
        break;
      case "work":
        this.updateWork(field, link);
        break;
    }
  }

  getNameField(name: string) {
    return [this.name, name, this.workId, this.index]
      .join("_")
      .replace(/\./g, "_");
  }

  get storeKey() {
    if (this.workId !== "_") {
      const ids = [this.index.toString()];

      if (notEmptyString(this.workId)) {
        ids.unshift(this.workId);
      }
      return ["link", this.name, ...ids].join("-");
    } else {
      return "";
    }
  }

  get genNameTitle() {
    return this.getNameField("title");
  }

  get genNameUrl() {
    return this.getNameField("url");
  }

  get genNameDescription() {
    return this.getNameField("description");
  }

  get hasValidUrl() {
    return validUrl(this.url);
  }

  get hasTitle() {
    return notEmptyString(this.title);
  }

  get titlePlaceholder() {
    return this.titleError ? `Please add a title for this link` : "Link title";
  }

  validate() {
    this.urlError = false;
    this.titleError = false;
    if (this.hasTitle && !this.hasValidUrl && this.urlRequired) {
      this.urlError = true;
      this.placeholder = "URL: please add a link";
    } else if (this.hasValidUrl && !this.hasTitle) {
      this.titleError = true;
    }
  }

  fieldClasses(key = "") {
    const cls = [this.fieldClass(key)];
    if ((key === "url" && this.urlRequired) || key === "title") {
      cls.push("required");
    }
    return cls;
  }

  fieldClass(key = "") {
    switch (key) {
      case "title":
        return this.titleError ? "error" : "ok";
      case "url":
        return this.urlError ? "error" : "ok";
      default:
        return "ok";
    }
  }

  @Watch("title")
  changeTitle() {
    this.validate();
    this.update();
  }
  @Watch("url")
  changeUrl() {
    this.validate();
    this.update();
  }
  @Watch("description")
  changeDescription() {
    this.update();
  }
  updateSub(field: string, link = null) {
    const refField = this.submission[field];
    this.updateRefField(refField, link);
  }

  updateRefField(refField = null, link) {
    if (refField instanceof Array) {
      if (this.index >= 0) {
        if (this.index < refField.length) {
          refField[this.index] = link;
        } else {
          refField.push(link);
        }
        bus.$emit("update-work-link", {
          index: this.index,
          link,
          workId: this.workId,
        });
      }
    }
  }

  handleFocus() {
    if (emptyString(this.url)) {
      this.placeholder = "https:// ";
      if (this.hasTitle) {
        this.placeholder += " --- Please add a link";
      }
    }
  }

  handleBlur() {
    this.url = this.url.trim();
    if (/^https?:\/?\/?$/.test(this.url)) {
      this.url = "";
    } else if (
      !/^https?:\/?\/?/.test(this.url) &&
      /^\w+[a-z0-9._-]*?\.\w+[a-z0-9._-]*?(\/[^ ]*?)?(#.*?)?(\?.*?)?$/i.test(
        this.url
      )
    ) {
      this.url = ["https:", this.url].join("//");
    }
  }

  updateWork(field: string, link = null) {
    const work = this.submission.works.find((w) => this.workId === w._id);
    if (work instanceof Work && link instanceof Object) {
      if (this.index >= 0) {
        const refField = work[field];
        this.updateRefField(refField, link);
      }
    }
  }

  deleteItem() {
    const [section, field] = this.name.split(".");
    let refField = [];
    if (this.index > 0) {
      if (section === "work") {
        const work = this.submission.works.find((w) => this.workId === w._id);
        if (work instanceof Work) {
          if (this.index >= 0) {
            refField = work[field];
            bus.$emit("delete-work-link", {
              index: this.index,
              workId: this.workId,
            });
          }
        }
      } else {
        const fieldName = field.split(".").pop();
        refField = this.submission[fieldName];
        setTimeout(() =>{
          bus.$emit("link-field-removed", {
            index: this.index,
            fieldName,
          });
        }, 250);
      }
      if (refField instanceof Array && this.index < refField.length) {
        for (let i = this.index; i < refField.length; i++) {
          const sk = this.storeKey.replace(/-\d+$/, "-" + i);
          this.$ls.remove(sk);
        }
        refField.splice(this.index, 1);      }
    } else {
      this.title = "";
      this.url = "";
      this.description = "";
    }
  }
}
